import { TOKEN_TYPE } from 'providers/constants/tokenNames';

/** Удалить токены из адресной строки */
export function deleteTokenFromSearchParams() {
    const searchParams = new URLSearchParams(window.location.search);

    [TOKEN_TYPE.CLIENT, TOKEN_TYPE.MANAGER, TOKEN_TYPE.EXTERNAL].forEach(tokenName => {
        searchParams.delete(tokenName);
    });

    const searchParamsString = `${searchParams}`;
    const newSearchParams = `${searchParamsString.length ? '?' : ''}${searchParamsString}`;
    const newUrl = window.location.origin + window.location.pathname + newSearchParams;

    window.history.replaceState(null, '', newUrl);
}
